import * as React from 'react';
import { compose, withHandlers } from 'recompose';
import { createStyles } from '@material-ui/styles';
import { PlatformPublicLayout } from '../PlatformPublicLayout';
import { withBaseProps } from '../../Utils';
import { Text } from '../../Text';
import { Button, ButtonVariants } from '../../Button';
const styles = (theme) => createStyles({
    pageContent: {
        zIndex: 110,
        position: 'relative',
        background: theme.color.background.light,
        maxWidth: 400,
        width: '100%',
        borderRadius: theme.common.borderRadius.default,
        boxShadow: '0 24px 24px 0 rgba(0, 0, 0, 0.3), 0 0 24px 0 rgba(0, 0, 0, 0.22)',
        marginBottom: 70,
        padding: 50,
        textAlign: 'center',
    },
    goToHomeBtn: {
        marginTop: theme.space.margin.large,
    },
});
const ApplicationErrorPage = (props) => {
    const { classes, onGoToHome, redirectBtnLabel, appErrorLabel, tenantName, imagesBaseUrl } = props;
    return (React.createElement(PlatformPublicLayout, { tenantName: tenantName, imagesBaseUrl: imagesBaseUrl },
        React.createElement("div", { className: classes.pageContent },
            React.createElement(Text, { size: 30, bold: true }, appErrorLabel || 'Application error'),
            React.createElement(Button, { role: ButtonVariants.primary, className: classes.goToHomeBtn, onClick: onGoToHome, label: redirectBtnLabel || 'Return to home' }))));
};
const ComposedApplicationErrorPage = compose(withBaseProps({ styles }), withHandlers({
    onGoToHome: ({ redirectUrl }) => () => {
        window.location.href = redirectUrl || window.location.origin;
    },
}))(ApplicationErrorPage);
ComposedApplicationErrorPage.displayName = 'ApplicationErrorPage';
export default ComposedApplicationErrorPage;
//# sourceMappingURL=ApplicationErrorPage.js.map